import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //   .use(LanguageDetector)
  .use(initReactI18next)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'nl-BE',
    debug: process.env.REACT_APP_IS_LOCAL === 'true',
    // options https://www.npmjs.com/package/i18next-http-backend
    backend: {
      loadPath: `https://${process.env.REACT_APP_STREAMING_DOMAIN}/api/static/{{lng}}-translation.json?type=translation`,
    },
  });

export default i18n;
